import { ReactNode } from 'react'
import styles from './SectionHeading.module.css'

/**
 * 시안의 인라인 반복 패턴(`<h2 class="t">...</h2><span>N건</span><span class="src ...">...</span>`) 이식.
 * 이름은 `SectionHeading` 이 맞다 — 계획서 File Structure 의 `SectionHeader` 는 오기다.
 */
export type SectionHeadingProps = {
  level?: 2 | 3
  title: string
  count?: string
  badge?: ReactNode
  right?: ReactNode
  id?: string
}

export const SectionHeading = ({ level = 2, title, count, badge, right, id }: SectionHeadingProps): JSX.Element => {
  const Heading = level === 3 ? 'h3' : 'h2'
  const headingClassName = level === 3 ? styles.h3 : styles.h2

  return (
    <div className={styles.wrap} id={id}>
      <Heading className={headingClassName}>{title}</Heading>
      {count ? <span className={styles.count}>{count}</span> : null}
      {badge}
      {right ? (
        <>
          <span className={styles.spacer} />
          {right}
        </>
      ) : null}
    </div>
  )
}
